export const defMinutesCron = {
    minutes: "0/1",
    hours: "*",
    monthday: "*",
    month: "*",
    weekday: "?",
};
export const defHourlyCronFirst = {
    minutes: "0",
    hours: "0/1",
    monthday: "*",
    month: "*",
    weekday: "?",
};
export const defWeeklyCronFirst = {
    minutes: "0",
    hours: "12",
    monthday: "*",
    month: "*",
    weekday: "?",
};
export const defWeeklyCronSecond = {
    minutes: "0",
    hours: "12",
    monthday: "?",
    month: "*",
    weekday: "MON-FRI",
};
export const defWeeklyCronThird = {
    minutes: "0",
    hours: "12",
    monthday: "?",
    month: "*",
    weekday: "*",
};
export const defMonthlyCronFirst = {
    minutes: "0",
    hours: "12",
    monthday: "1",
    month: "1/1",
    weekday: "?",
};
export const defMonthlyCronSecond = {
    minutes: "0",
    hours: "12",
    monthday: "?",
    month: "1/1",
    weekday: "MON#1",
};
export const defYearlyCronFirst = {
    minutes: "0",
    hours: "12",
    monthday: "1",
    month: "1",
    weekday: "?",
};
export const defYearlyCronSecond = {
    minutes: "0",
    hours: "12",
    monthday: "?",
    month: "1",
    weekday: "MON#1",
};
//# sourceMappingURL=defaultCronOptions.js.map